import { render } from "./AssetInfoModal.vue?vue&type=template&id=3a0ea166"
import script from "./AssetInfoModal.vue?vue&type=script&lang=js"
export * from "./AssetInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__